module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-800x2-c875e773cd8f54367e53a5e87a045105.jpg";